import { useMemo } from "react";
import { useApp } from "../../../services/app-context";
import { useUser } from "../../../services/user-context";
import { getPractitionerTypes } from "../../../services/utils";


function PractitionerButton({ label, onClick, selected }: { label: string, onClick: () => void, selected: boolean }) {
    return (
        <button className={`shrink-0 whitespace-nowrap rounded-full px-4 py-2 text-[clamp(12px,1.5vw,14px)] font-semibold ${selected ? "bg-PraxisDarkRed text-white font-semibold" : "text-black border border-gray-200"}`} onClick={onClick}>
            {label}
        </button>
    );
}

export function PractitionerSelector({ onChange, value }: { onChange: (value: string) => void, value: string }) {
    const { tenantProfile } = useApp();
    const { userInfo } = useUser() as any;
    const group = userInfo?.group;
    const practitionerTypes: { type: string, image: string, key: string }[] = useMemo(() => {
        return getPractitionerTypes(tenantProfile?.practitioner_types || {}, group) || [];
    }, [tenantProfile, group]);
    return (
        <div data-testid="practitioner-selector" className="flex gap-2 items-center max-w-[calc(100vw-390px)] py-2 overflow-x-auto">
            <PractitionerButton label="All Sessions" onClick={() => onChange("all")} selected={!value || value === "all"} />
            {
                practitionerTypes.map((practitionerType) => {
                    const id = practitionerType.key || practitionerType.type;
                    const label = practitionerType.type || practitionerType.key;
                    return (
                        <PractitionerButton key={id} label={label} onClick={() => onChange(id)} selected={value === id} />
                    );
                })
            }
        </div>
    );
}       